import { createSlice } from "@reduxjs/toolkit";

const mySlice = createSlice({
  name: "cart",
  initialState: {
    isFetching: false,
    isUpdating: false,
    isReportFetching: false,
    openConfirmationModal: false,
    all: null,
    new: null,
    selected: null,
    reportData: null,
  },
  reducers: {
    setAll(state, action) {
      state.all = action.payload;
    },
    setIsFetching(state, action) {
      state.isFetching = action.payload;
    },
    setIsUpdating(state, action) {
      state.isUpdating = action.payload;
    },
    setIsReportFetching(state, action) {
      state.isReportFetching = action.payload;
    },
    setNew(state, action) {
      state.new = action.payload;
    },
    setSelected(state, action) {
      state.selected = action.payload;
    },
    setReportData(state, action) {
      state.reportData = action.payload;
    },
  },
});

export const myCartActions = mySlice.actions;

export default mySlice.reducer;
